import { useMemo } from 'react';
import { useStateSelector } from '../data/global/dataSelectors';
import { IsVirtualEnvironment } from '../data/global/selectors/environmentSelector';

export const useVirtualTrading = () => {
  const isVirtualEnv = useStateSelector(IsVirtualEnvironment);

  return useMemo(() => ({ isVirtualEnv }), [isVirtualEnv]);
};
